import { cx } from './cx';
import type { ShopProductType } from '@pc/db';

const LABEL: Record<ShopProductType, string> = {
  peptide: 'Peptide',
  sarm: 'SARM',
  serm: 'SERM',
  nootropic: 'Nootropic',
  hormone: 'Hormone',
  amino_acid: 'Amino acid',
  vitamin: 'Vitamin',
  ancillary: 'Ancillary',
  research_chemical: 'Research chemical',
  accessory: 'Accessory',
  other: 'Other',
};

export const PRODUCT_TYPES: ReadonlyArray<{ value: ShopProductType; label: string }> = (
  Object.entries(LABEL) as Array<[ShopProductType, string]>
).map(([value, label]) => ({ value, label }));

export interface ProductTypePillProps {
  type: ShopProductType;
  className?: string;
}

export function ProductTypePill({ type, className }: ProductTypePillProps) {
  return (
    <span
      className={cx(
        'inline-flex items-center px-2 py-0.5 text-[11px] tracking-wide uppercase',
        'bg-paper-2 text-ink/80 border border-rule',
        className,
      )}
    >
      {LABEL[type]}
    </span>
  );
}
